export default {
  file: null,
  files: null,
  defaultfileTypesAccept:
    "image/jpeg, image/png, video/3gpp, video/mp4, text/plain, application/pdf, application/vnd.ms-powerpoint, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  defaultFileTypes: [
    { id: "image", name: "Imagen", accept: "image/jpeg, image/png", maxSize: 5000000 },
    { id: "video", name: "Video", accept: "video/3gpp, video/mp4", maxSize: 16000000 },
    {
      id: "document",
      name: "Documento",
      accept:
        "text/plain, application/pdf, application/vnd.ms-powerpoint, application/msword, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      maxSize: 100000000,
    },
  ],
};
